import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { CssBaseline, makeStyles } from '@material-ui/core';
import { AnalyticsProvider, useAnalytics } from "@zennya/web-component-library/src";
import { CustomToaster } from "components/CustomToaster";

import { NotFound } from 'pages/NotFound';
import { useEffect, useState } from "react";
import { Route, BrowserRouter as Router, Switch, matchPath, useLocation, useRouteMatch } from 'react-router-dom';
import { atom, useSetRecoilState } from "recoil";
import { Interceptor } from 'util/interceptor';
import { Chat } from "./Chat";
import { BookingNotFound } from './Details/BookingNotFound';
import { Layout } from './Layout';
import { Login } from './Login';
import { RecoilState } from "./RecoilState";
// import './index.css'
const useStyles = makeStyles((theme) => {
  return {}
})

const isJourneyVisibleState = atom({
  key: 'isJourneyVisible',
  default: false
})

const activeUserState = atom({
  key: 'activeUser',
  default: null
})

const analyticsIdentifierState = atom({
  key: 'analyticsIdentifier',
  default: null
})

const chatChannelState = atom({
  key: 'chatChannel',
  default: null
})
const medicalChatChannelState = atom({
  key: 'medicalChatChannel',
  default: null
})

const providerChatChannelState = atom({
  key: 'providerChatChannel',
  default: null
})


const openProviderChatState = atom({
  key: 'openProviderChatState',
  default: false
})

const PROVIDER_CHAT = 'provider'
const SUPPORT_CHAT = 'support'
const CLOSE_CHAT = 'close'
const MEDICAL_CHAT = 'medical'

const openChatState = atom({
  key: 'openChatState',
  default: CLOSE_CHAT
})

const chatAttachmentState = atom({
  key: 'chatAttachmentState',
  default: null
})

const errorStackState = atom({
  key: 'errorStackState',
  default: []
})

const AnonIdentifier = () => {
  const { identifyAnon } = useAnalytics()

  useEffect(
    () => {
      identifyAnon()
    }, []
  );
  return <></>
}

const Booking = ({ }) => {
  const setChatOpen = useSetRecoilState(openChatState);

  const pathCheck = {
    path: [
      '/bookings/login/:serviceId',
      '/bookings/oops/:serviceId',
      '/bookings/:serviceId/code/:code',
      '/bookings/:serviceId/',
    ],
    strict: false,
    sensitive: true
  }
  const isRouteSvc = useRouteMatch(pathCheck)
  const location = useLocation()
  const [svcId, setSvcId] = useState(isRouteSvc?.params?.serviceId);
  useEffect(
    () => {
      const match = matchPath(location.pathname, pathCheck)
      console.log('index.jsx (103)', match)
      setSvcId(match?.params?.serviceId)
    }, [location]
  );



  const classes = useStyles()
  return (
    <AnalyticsProvider writeKey={process.env.REACT_APP_SEGMENT_KEY} appIdentifier="CLIENT WEB BOOKING" eventPrefix="B2B-B2C">
      <Router>
        <Interceptor quiet />

        <RecoilState serviceId={svcId}>
          <CustomToaster
            onChatOpen={() => {
              setChatOpen(SUPPORT_CHAT)
            }}
          />
          <Chat serviceId={svcId} source="Whitelabel" />
          <CssBaseline />

          <Switch>
            {/* <Route exact path="/bookings/:serviceId/code/:code" component={BookingCodeProcess} /> */}
            <Route path="/bookings/oops/:serviceId" exact component={BookingNotFound} />
            <Route path="/bookings/notfound/:serviceId" exact component={NotFound} />
            <Route path="/bookings/login" component={Login} />
            <Route path="/bookings/:serviceId" render={(props) => <Layout {...props} onSetSvcId={svc => setSvcId(svc)} />} />
            {/* <Route>
              <BookingNotFound />
            </Route> */}
          </Switch>


        </RecoilState>
      </Router>
    </AnalyticsProvider>
  )
}

export {
  Booking, 
  CLOSE_CHAT,
  MEDICAL_CHAT, 
  PROVIDER_CHAT,
  SUPPORT_CHAT, 
  activeUserState,
  analyticsIdentifierState, 
  chatAttachmentState, 
  chatChannelState, 
  errorStackState, 
  medicalChatChannelState, 
  openChatState, 
  openProviderChatState, 
  providerChatChannelState,
  isJourneyVisibleState
};

